import httpClient from "../http/http-client";
import { IDashboardElement, IPostDashboardElement } from '../dashboard/dashboard.model';

export default class DashboardElementService {
  http;

  constructor() {
    this.http = httpClient;
  }

  async getAll(): Promise<IDashboardElement[]> {
    return this.http.get('dashboard-element')
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; });
  }

  async getOne(id: string): Promise<IDashboardElement> {
    return this.http.get(`dashboard-element/${id}`)
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; });
  }

  async create(element: IPostDashboardElement): Promise<IDashboardElement> {
    return this.http.post('dashboard-element', element)
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; });
  }

  async edit(id: string, element: IPostDashboardElement): Promise<IDashboardElement> {
    return this.http.patch(`dashboard-element/${id}`, element)
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; });
  }

  async remove(id: string): Promise<{ message: string }> {
    return this.http.delete(`dashboard-element/${id}`)
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; });
  }
}
